import { NgModule } from '@angular/core';
import { SystemNoteEditComponent } from './system-note-edit/system-note-edit.component';
import { SystemNoteListComponent } from './system-note-list/system-note-list.component';
import { SharedModule } from '../shared/shared.module';
import { SystemNoteListService } from '../core/service/grid-data/grid-data-system-note.service';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    SystemNoteListComponent,
    SystemNoteEditComponent
  ],
  exports: [
    SystemNoteListComponent,
    SystemNoteEditComponent
  ],
  providers: [
    SystemNoteListService
  ]
})
export class SystemNoteModule { }
